import { NextSeo } from 'next-seo';
import { FC } from 'react';

import { StringParam, useQueryParams } from '@/hooks/useQueryParams';
import { useResource } from '@/lib/datx-jsonapi-react';
import { getNewsArticleById } from '@/queries/news-articles';
import { splitIdAndSlug } from '@/utils/helperFunctions';

export const NewsPageSeo: FC = () => {
  const { id: articleSlug } = useQueryParams<{ id: string }>({
    id: StringParam,
  });

  const { id: articleId } = splitIdAndSlug(articleSlug);

  const { data: article, isValidating } = useResource(getNewsArticleById(articleId));

  if (!article && isValidating) {
    return null;
  }

  return (
    <NextSeo
      title={article.title}
      openGraph={{
        url: `${process.env.NEXT_PUBLIC_BASE_URL}news/${article.linkSlug}`,
        title: article.title,
        description: article.summary,
        images: [
          {
            url: article.mediumFeaturedImageUrl || `${process.env.NEXT_PUBLIC_BASE_URL}images/landing/hero-share.jpg`,
            width: 800,
            height: 600,
            alt: `Photo - ${article.title}`,
          },
        ],
      }}
    />
  );
};
